import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => {
  const avatarSize = size => {
    switch (size) {
      case 'large':
        return 74;
      case 'small':
        return 40;
      default:
        return size;
    }
  };

  return {
    container: {
      backgroundColor: theme.palette.custom.surface[3],
      fontSize: props => avatarSize(props.size),
      width: '1em',
      height: '1em',
      borderRadius: '50%',
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      '& .avatar': {
        '&-img': {
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        },
        '&-icon': {
          fontFamily: 'Material Icons',
          color: theme.palette.custom.background.area,
          fontSize: props => (props.size === 'small' ? '' : '.6em'),
        },
      },
    },
  };
});

export default styles;
